import { render, staticRenderFns } from "./addTable.vue?vue&type=template&id=ffbcc30e&scoped=true&"
import script from "./addTable.vue?vue&type=script&lang=js&"
export * from "./addTable.vue?vue&type=script&lang=js&"
import style0 from "./addTable.vue?vue&type=style&index=0&id=ffbcc30e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffbcc30e",
  null
  
)

export default component.exports